// Your actual Stripe publishable key
export const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51S2Oj20eu3Zp2kSYMVIdoqMJP0hwvAL4nq3iEFFyIDxl9t8AJkRyApeiR2O1P67XE6kAEB7Fa6w3H6PRW5ZjC3PA00JkUuRA4R';

// Check if we have a valid key
export const isStripeConfigured = () => {
  return stripePublishableKey && stripePublishableKey.startsWith('pk_');
};

// Stripe configuration options
export const stripeOptions = {
  locale: 'auto',
};